import "@/App.css";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { RoleMarquee } from "@/components/Marquee";
import { Services } from "@/components/Services";
import { Manifesto } from "@/components/Manifesto";
import { Audience } from "@/components/Audience";
import { Booking } from "@/components/Booking";
import { Footer } from "@/components/Footer";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
      <div className="App">
        <Navbar />
        <main>
          <Hero />
          <RoleMarquee />
          <Services />
          <Manifesto />
          <Audience />
          <Booking />
        </main>
        <Footer />
        <Toaster position="bottom-right" />
      </div>
    </ReactLenis>
  );
}

export default App;
